export enum CustomerAddressTypeEnum {
    EXISTING_CUSTOMER_ADDRESS = "ExistingCustomerAddress",
    EXISTING_CUSTOMER_PROSPECT_CUSTOMER_ADDRESS = "ExistingCustomerProspectCustomerAddress",
    PROSPECT_CUSTOMER_ADDRESS = "ProspectCustomerAddress",
    SURVEY_PROSPECT_CUSTOMER_ADDRESS = "SurveyProspectCustomerAddress"
}
